module.exports = __webpack_public_path__ + "ap.no2.c30734c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ap.no2.jpg
// module id = OJd2
// module chunks = 0